




























import Vue from 'vue'
export default Vue.extend({
    name: 'Breadcrumb',
    data () {
        return {
        breadcrumbList: []
        }
    },
    mounted () { this.updateList() },
    watch: { '$route' () { this.updateList() } },
    methods: {
        routeTo (pRouteTo: any) {
            if (this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
            if (this.breadcrumbList[pRouteTo].namedLink) {
                if (this.$route.params.id) {
                    this.$router.push({ name: this.breadcrumbList[pRouteTo].namedLink, params: { id: this.$route.params.id } })
                } 
                this.$router.push({ name: this.breadcrumbList[pRouteTo].namedLink })
            }
        },
        updateList () { this.breadcrumbList = this.$route.meta.breadcrumb },
        hasIcon(name) {
            switch (name) {
                case 'Home':
                    return true;
                default:
                    return false;
            }
        }
    }
})
